module.exports = __webpack_public_path__ + "static/img/Laddoo.7f9ca3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stamp Assests/Laddoo.svg
// module id = 6wXh
// module chunks = 1